import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationService {
  private email$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private readonly baseUrl: string =
    this.configService.getApiBaseUrl() + '/email-validation';

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
    private translateService: TranslateService,
  ) { }

  setEmail(email: string): void {
    this.email$.next(email);
  }

  getEmail(): Observable<string> {
    return this.email$.asObservable();
  }

  generateCode(): Observable<{ uuid: string; }> {
    const email = this.email$.getValue();
    if (!email) {
      return throwError('You must set the email before generating the confirmation code.');
    }
    const searchParams = new URLSearchParams();
    searchParams.append('email', email);
    return this.httpClient.get<{ uuid: string; }>(`${this.baseUrl}?${searchParams.toString()}`, {
      headers: {
        'Accept-Language': this.translateService.currentLang,
      }
    });
  }
}
